import { useCallback, useMemo, useState } from 'react';
import { flatten, safeParse } from 'valibot';

import type { Hook, Result, Validate } from './types';

export const useValidation: Hook = ({
  schema,
}) => {
  const [issues, setIssues] = useState<Result<typeof schema>['issues']>(
    undefined,
  );

  const validate = useCallback<Validate<typeof schema>>((data) => {
    const validatoinResult = safeParse(schema, data);
    const { success, issues: validationIssues } = validatoinResult;

    setIssues(success ? null : validationIssues);

    return validatoinResult;
  }, [schema]);

  const errorMessageMap = useMemo<Result<typeof schema>['errorMessageMap']>(
    () => (
      issues
        ? flatten(issues).nested
        : null
    ),
    [issues],
  );

  return {
    errorMessageMap,
    issues,
    validate,
  };
};
